import { useState } from 'react';

interface UseNestedMenuOpenParams {
  isChildActive: boolean;
}

export const useNestedMenuOpen = ({ isChildActive }: UseNestedMenuOpenParams) => {
  const [isManuallyOpen, setIsManuallyOpen] = useState(false);

  const isOpen = isChildActive || isManuallyOpen;

  const toggle = () => {
    if (isChildActive) return;
    setIsManuallyOpen((prev) => !prev);
  };

  return { isOpen, toggle };
};
